import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getPhotoMessages = async (photoId) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to get messages');
  }
  
  return response.json();
};

export const sendMessage = async (photoId, content) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ content })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to send message');
  }
  
  return response.json();
};

export const deleteMessage = async (photoId, messageId) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages/${messageId}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to delete message');
  }
  
  return response.json();
};

export const addReaction = async (photoId, messageId, emoji) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages/${messageId}/reactions`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ emoji })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to add reaction');
  }
  
  return response.json();
};

export const removeReaction = async (photoId, messageId, emoji) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages/${messageId}/reactions/${encodeURIComponent(emoji)}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to remove reaction');
  }
  
  return response.json();
};

export const getMessageCount = async (photoId) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/messages/count`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    return { count: 0 };
  }
  
  return response.json();
};

export const sendTypingSignal = async (photoId) => {
  const response = await fetch(`${API_URL}/api/photos/${photoId}/typing`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    return { status: 'error' };
  }
  
  return response.json();
};
